import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { BaseEntityResource } from '../../core/abstractions/base-entity.resource';
import { ApiResponseModel } from '../../models/core/api-response.model';
import { ResourceConfig } from '../../models/core/resource.config';
import { FileShareModel } from '../../models/file-share.model';

@Injectable({
    providedIn: 'root'
})
export class FileSharesResource extends BaseEntityResource<FileShareModel> {
    constructor() {
        super(new ResourceConfig({ baseController: 'file-shares' }));
    }

    /**
     * Returns all available shares.
     */
    getAll(): Observable<ApiResponseModel<FileShareModel[]>> {
        return this._requestService.makeGet<ApiResponseModel<FileShareModel[]>>(this.getUrl(''));
    }
}
